const TortillaIntro = () => {
  return (
    <img alt="Tortilla Intro" src="/static/tortilla/intro.png" style={{ maxHeight: 'fit-content', margin: '0 auto' }} />
  );
};

export default TortillaIntro;
